'use client';

import { useState } from 'react';

import { EmailUnsubscribeApiParams } from '../apis';

import { clientAxios } from '@/shared/api';

interface EmailUnsubscribeData {
  msg: string;
  status: string;
  flag_type?: string;
  flag_info?: string;
}

const useEmailUnSubscribeApi = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [data, setData] = useState<EmailUnsubscribeData | null>(null);

  const fetchEmailUnSubscribeApi = async ({
    hash,
    flag,
  }: EmailUnsubscribeApiParams) => {
    setIsLoading(true);

    try {
      const { data } = await clientAxios.post('/emailUnsubscribeApi', {
        hash,
        flag,
      });
      if (data.ok) {
        setData(data.data);
      }
    } catch (e) {
      setData(null);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    isError,
    data,
    fetch: fetchEmailUnSubscribeApi,
  };
};

export default useEmailUnSubscribeApi;
